import { EItemScreenMode } from '@modules/items/stores/useItemScreenStore';

export const AVAILABLE_SCREEN_MODES: EItemScreenMode[] = [EItemScreenMode.COMMENTS];
